import {
  ApiConfigModel,
  FetchHtmlResponse,
  PatchApiConfigRequest,
  PostApiConfigRequest,
  PostExtractRequest,
} from "@/shared/model/api-config.model";
import { Client } from "./client";

export class ApiConfigApi {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  async createApiConfig(data: PostApiConfigRequest): Promise<ApiConfigModel> {
    const response = await this.client.fetch(`/api-config`, {
      method: "POST",
      body: JSON.stringify(data),
    });

    const json = await response.json();
    return json.data as ApiConfigModel;
  }

  async getApiConfig(id: string): Promise<ApiConfigModel> {
    const response = await this.client.fetch(`/api-config/${id}`);

    const json = await response.json();
    return json.data as ApiConfigModel;
  }

  async getApiConfigList(): Promise<ApiConfigModel[]> {
    const response = await this.client.fetch(`/api-config`);

    const json = await response.json();
    return json.data as ApiConfigModel[];
  }

  async updateApiConfig(
    id: string,
    data: PatchApiConfigRequest
  ): Promise<ApiConfigModel> {
    const response = await this.client.fetch(`/api-config/${id}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    });

    const json = await response.json();
    return json.data as ApiConfigModel;
  }

  async fetchHtml(id: string): Promise<FetchHtmlResponse> {
    const response = await this.client.fetch(`/api-config/${id}/html`);

    const json = await response.json();
    return json.data;
  }

  async extract(
    id: string,
    apiKey: string,
    body: PostExtractRequest
  ): Promise<any> {
    const url = this.client.baseUrl;

    const response = await fetch(`${url}/api-config/${id}/extract`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "x-api-key": apiKey,
        "Content-Type": "application/json",
      },
    });

    const contentType = response.headers.get("Content-Type");

    if (contentType?.includes("text/csv")) {
      return await response.text();
    } else {
      const json = await response.json();
      return json;
    }
  }

  async deleteApiConfig(id: string): Promise<void> {
    await this.client.fetch(`/api-config/${id}`, {
      method: "DELETE",
    });
  }
}
